import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useThemeMode } from "../../ThemeContext";
import { APP_URLS } from "../../helpers/url_helper";

// Import assets for DemoTrail section
import SecureIcon from "../../assets/icon-secure.svg";
import AiIcon from "../../assets/icon-ai.svg";
import TeamsIcon from "../../assets/icon-teams.svg";

// Import dark theme images
import DarkDashboard from "../../assets/landing_page_images/Dark-Dashboard.webp";
import DarkChat from "../../assets/landing_page_images/Dark-Chat.webp";
import DarkDocument from "../../assets/landing_page_images/Dark-Document.webp";

// Import light theme images
import LightDashboard from "../../assets/landing_page_images/Light-Dashboard.webp";
import LightChat from "../../assets/landing_page_images/Light-Chat.webp";
import LightDocument from "../../assets/landing_page_images/Light-Document.webp";

function DemoTrail() {
  const { mode } = useThemeMode();

  return (
    <>
      {/* Hero Section */}
      <section className="pb-5 pt-3 bg-white position-relative hero-bg-pattern">
        <Container className="text-center">
          <Row className="justify-content-center mb-4">
            <Col xs={12}>
              <div className="hero-strip d-flex flex-wrap justify-content-center gap-3 mb-3">
                <div className="hero-strip-item">
                  <img
                    src={SecureIcon}
                    alt="Secure"
                    className="hero-strip-icon img-fluid"
                  />
                  <div className="hero-strip-label">Secure & Encrypted</div>
                </div>
                <div className="hero-strip-item">
                  <img
                    src={AiIcon}
                    alt="AI"
                    className="hero-strip-icon img-fluid"
                  />
                  <div className="hero-strip-label">AI-Powered Platform</div>
                </div>
                <div className="hero-strip-item">
                  <img
                    src={TeamsIcon}
                    alt="Teams"
                    className="hero-strip-icon img-fluid"
                  />
                  <div className="hero-strip-label">Used by Teams</div>
                </div>
              </div>
              <h1 className="section-title">
                WHS & Compliance Management Software for Australian Businesses
              </h1>

              <h2 className="section-subtitle mx-auto">
                Fast, Effective, Measurable Compliance.
              </h2>

              <p
                className="section-description mx-auto"
                style={{ maxWidth: "900px" }}
              >
                Complimate is WHS software and compliance management software
                that helps Australian businesses manage work health and safety,
                documents, audits, digital forms, corrective actions, tasks and
                compliance records in one place. Draft policies and procedures,
                run audits, manage safety actions and get answers from your
                compliance documents with AI-powered tools.
              </p>

              <div className="d-flex gap-3 justify-content-center mb-4 flex-wrap">
                <Button
                  as={Link}
                  to="/contact-us"
                  id="book_a_demo_banner"
                  variant="outline-primary"
                  className="btn-outline-teal"
                >
                  Book a Demo
                </Button>

                <Button
                  as={Link}
                  to={APP_URLS.SIGNUP}
                  id="get_started_banner"
                  variant="primary"
                  className="btn-teal"
                >
                  Get started
                </Button>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center hero-images-row">
            <Col xs={12} md={4} className="mb-3 mb-md-0">
              <div
                className="rounded-4 overflow-hidden shadow-sm w-100 hero-image-container"
                style={{ height: "280px" }}
              >
                <img
                  src={mode === "dark" ? DarkDashboard : LightDashboard}
                  alt="Complimate dashboard"
                  width={1145}
                  height={855}
                  fetchPriority="high"
                  decoding="async"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </div>
            </Col>
            <Col xs={12} md={4} className="mb-3 mb-md-0">
              <div
                className="rounded-4 overflow-hidden shadow-sm w-100 hero-image-container"
                style={{ height: "280px" }}
              >
                <img
                  src={mode === "dark" ? DarkChat : LightChat}
                  alt="Complimate assistant chat"
                  width={1145}
                  height={855}
                  decoding="async"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </div>
            </Col>
            <Col xs={12} md={4}>
              <div
                className="rounded-4 overflow-hidden shadow-sm w-100 hero-image-container"
                style={{ height: "280px" }}
              >
                <img
                  src={mode === "dark" ? DarkDocument : LightDocument}
                  alt="Complimate documents"
                  width={1145}
                  height={855}
                  decoding="async"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default DemoTrail;
